/**
 * @file 配置
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/config
 */
import cookie from './cookie';
import { extend, toQuery } from './json';
import getEnv from './env';
import loadScript from './loadScript';
import delay from './delay';
import getReqIdx from './requestIndex';
var isClient = typeof window !== 'undefined';

var _ref = isClient && location,
    _ref$hostname = _ref.hostname,
    hostname = _ref$hostname === void 0 ? '' : _ref$hostname;

var isTestReg = /^(?=test[0-9]?\b|beta[0-9]?\b|dev[0-9]?\b|localhost\b|(?:[0-9]{1,3}\.){3}[0-9]{1,3}\b)/;
/**
 * 上报的域名
 *
 * @const {string}
 */

var DOMAIN = function (host) {
  return "//".concat(isTestReg.test(hostname) ? 'test-' : '').concat(host, "/");
}('i.gsxtj.com');
/**
 * 上报的公共字段 name 的值
 *
 * @const {string}
 */


var NAME = function (host) {
  return {
    baijiahulian: ''
  }[host] || host;
}(hostname.replace(/^[^.]+\.|(100)?\.[^.]+$/g, ''));

var ENV = isClient ? getEnv().env : 0;
/**
 * 上报路径相关的配置
 *
 * @enum {string|number}
 */

export var Config = {
  /**
   * 上报域名
   */
  DOMAIN: DOMAIN,

  /**
   * 项目标识名，格式：业务线-产品标识
   */
  NAME: NAME,

  /**
   * 宿主标识
   */
  ENV: ENV,

  /**
   * 配置提交上报的 HTTP VERB
   */
  VERB: 'post',

  /**
   * PV 的上报路径
   */
  PV: 'pv0.gif',

  /**
   * 点击、展开的上报路径
   */
  GS: 'gs.gif',

  /**
   * 性能相关指标上报路径
   */
  PERF: 'perf.gif',

  /**
   * 时间统计相关的上报路径
   */
  TIME: 'time.gif',

  /**
   * 数据追踪的上报路径
   */
  TRACE: 'trace.gif',

  /**
   * 页面停留时长的上报路径
   */
  STAY: 'stay.gif',

  /**
   * 批量上报，主用于视频相关的上报
   */
  BATCH: 'batch_event.gif',

  /**
   * gid 服务请求路径
   */
  GID: 'habo/gid.js',

  /**
   * 是否延迟发送请求，默认开启
   */
  DELAY: true
};
/**
 * 全局追踪统计的用户唯一标识
 *
 * @type {string}
 */

export var trackID = isClient ? cookie.get('__track_id__') : '';
/**
 * 登录户标识
 *
 * @type {string}
 */

export var userID = isClient ? cookie.get('user_id') : '';
/**
 * 全局附加字段
 *
 * @type {Object}
 */

export var extraData = {
  gid: ''
};
/**
 * 注意 NAME 上报
 *
 * @function
 * @param {string} queryString 要注入的源数据
 * @return {string} 返回注入 name=NAME 后的源数据
 */

export var injectCommonField = function injectCommonField(queryString, addionalParams) {
  if (!queryString) {
    return '';
  } // 注入业务线-产品代号


  if (!/(?:&|^)name=/.test(queryString)) {
    if (!Config.NAME) {
      console.warn('no habo field `name`!');
    }

    queryString += "&name=".concat(encodeURIComponent(Config.NAME));
  } // 注入客户端类型


  if (!/(?:&|^)env=/.test(queryString)) {
    queryString += "&env=".concat(encodeURIComponent(Config.ENV));
  }

  queryString = "".concat(queryString.replace(/(&|^)ver=[^&]+/g, ''), "&ver=").concat("2.1.4");
  queryString += "&".concat(toQuery(extraData));

  if (!/((?:^|&)t=)([^$&]*)/i.test(queryString)) {
    var now = (+new Date()).toString(36);
    queryString += "&t=".concat(now);
  }

  var type = addionalParams.type; // 注入 req_idx ，用于统计丢失率

  queryString += "&req_idx=".concat(getReqIdx(type, extraData.gid));
  return queryString.replace(/^&+/, '');
};
/**
 *  覆盖配置
 *
 * @function
 * @param {Object} defaults 覆盖上报相关的配置
 * @return {Object} 更新后的 Config
 */

export var setConfig = function setConfig(defaults) {
  return extend(Config, defaults);
};
var readyHandlerList = [];
/**
 * 判断config是否初始化完毕
 */

export var isReady = function isReady() {
  return readyHandlerList === null;
};
/**
 * 注册初始化完毕回调
 *
 * @param {Function} 回调函数
 */

export var onReady = function onReady(handler) {
  if (isReady()) {
    handler();
    return;
  }

  readyHandlerList.push(handler);
};

var execOnReady = function execOnReady() {
  readyHandlerList && readyHandlerList.forEach(function (handler) {
    return handler();
  });
  readyHandlerList = null;
};
/**
 * 初始化全局用户相关参数
 */


export var initExtraData = function initExtraData() {
  extraData.gid = cookie.get('GID');

  if (extraData.gid || !isClient) {
    execOnReady();
    return;
  }

  delay(function () {
    // 通过file协议访问本地静态文件时手动拼接https协议请求cdn上gid.js文件
    var isFileProtocol = document && document.location.protocol === 'file:';
    var GIDUrl = isFileProtocol ? "https:".concat(Config.DOMAIN).concat(Config.GID) : "".concat(Config.DOMAIN).concat(Config.GID);
    loadScript(GIDUrl, function () {
      extraData.gid = cookie.get('GID');
      return execOnReady();
    });
  })();
};